import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  visibility: ", ";\n"])), function (_ref) {
  var $hidden = _ref.$hidden;
  return $hidden ? 'hidden' : 'visible';
});
var TabsContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding-block: 0;\n  padding-inline: ", ";\n  display: flex;\n  overflow-x: auto;\n  min-width: 100%;\n\n  &::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 1px;\n    background-color: ", ";\n  }\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  ", " {\n    overflow: hidden;\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.sizing.small;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colours.canvas.primary.main;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.mqTo('sm');
});
var StyledCell = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  opacity: ", ";\n  padding-bottom: ", ";\n  padding-top: ", ";\n  min-width: fit-content;\n  position: relative;\n  border-top: ", ";\n\n  border-left: ", ";\n\n  border-right: ", ";\n\n  &::after {\n    content: '';\n    position: absolute;\n    z-index: 1;\n    bottom: 0;\n    width: 100%;\n    height: 2px;\n    background-color: ", ";\n    background-color: ", ";\n  }\n\n  > button {\n    opacity: ", ";\n\n    &:focus-visible,\n    &:hover {\n      ", ";\n      &:not(:disabled) {\n        ", "\n      }\n    }\n  }\n"])), function (_ref5) {
  var $disabled = _ref5.$disabled,
    theme = _ref5.theme;
  return $disabled ? theme.opacity.disabled : 1;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.sizing.tiny;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.sizing.tiny;
}, function (_ref8) {
  var theme = _ref8.theme,
    $active = _ref8.$active,
    $isParentTab = _ref8.$isParentTab;
  return $active && $isParentTab && "".concat(theme.sizing.xxtiny, " solid ").concat(theme.colours.canvas.primary.main);
}, function (_ref9) {
  var theme = _ref9.theme,
    $active = _ref9.$active,
    $isParentTab = _ref9.$isParentTab;
  return $active && $isParentTab && "".concat(theme.sizing.xxtiny, " solid ").concat(theme.colours.canvas.primary.main);
}, function (_ref10) {
  var theme = _ref10.theme,
    $active = _ref10.$active,
    $isParentTab = _ref10.$isParentTab;
  return $active && $isParentTab && "".concat(theme.sizing.xxtiny, " solid ").concat(theme.colours.canvas.primary.main);
}, function (_ref11) {
  var theme = _ref11.theme,
    $active = _ref11.$active,
    $isParentTab = _ref11.$isParentTab;
  return $active && !$isParentTab && theme.colours["interface"].main;
}, function (_ref12) {
  var theme = _ref12.theme,
    $active = _ref12.$active,
    $isParentTab = _ref12.$isParentTab;
  return $active && $isParentTab && theme.colours.canvas.tertiary.main;
}, function (_ref13) {
  var $active = _ref13.$active,
    theme = _ref13.theme;
  return $active ? 1 : theme.opacity.secondary;
}, function (_ref14) {
  var $disabled = _ref14.$disabled;
  return !$disabled && "opacity: 1;";
}, function (_ref15) {
  var $active = _ref15.$active;
  return $active && "background: transparent;";
});
var FlyoutCellContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n"])));
var ChevronContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  z-index: 2;\n  position: absolute;\n  bottom: ", ";\n  ", "\n  ", " {\n    display: none;\n  }\n"])), function (_ref16) {
  var theme = _ref16.theme;
  return theme.sizing.xtiny;
}, function (_ref17) {
  var $isRightAligned = _ref17.$isRightAligned;
  return $isRightAligned ? 'right: 0;' : 'left: 0;';
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.mqTo('sm');
});

export { ChevronContainer, Container, FlyoutCellContainer, StyledCell, TabsContainer };
//# sourceMappingURL=Tabs.styles.js.map
